import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import Cookies from 'js-cookie';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

export default function LectureSingleTeacher({ teacher }) {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = Cookies.get("i18next") || "en";

  const handelLecture = (lectureId) => {
    navigate(`/lecture/${id}/${lectureId}`);
  };

  return (
    <Paper sx={{ padding: { xs: "24px 16px", md: "32px 24px" }, marginY: "30px" }}>
      <Typography sx={{ fontSize: "22px", marginBottom: "18px" }}>
        {t('Lectures')}
      </Typography>

      <Box sx={{ overflowX: 'auto' }}>
        {teacher && teacher.length > 0 ? (
          <TableContainer component={Paper}>
            <Table  aria-label="lectures table">
              <TableHead>
                <TableRow>
                  <TableCell align="center" sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                    {t("Photo")}
                  </TableCell>
                  <TableCell align="center">{t("title")}</TableCell>
                  <TableCell align="center" sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                    {t("description")}
                  </TableCell>
                  <TableCell align="center" sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                    {t("price")}
                  </TableCell>
                  <TableCell align="center">{t("actions")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {teacher.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="center" sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                      <img
                        src={row.image ? `${process.env.REACT_APP_API_KEY}images/${row.image}` : "/logo.png"}
                        alt="lecture"
                        width="60"
                        style={{ maxWidth: '100%', borderRadius: '6px' }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      {lang === "ar" ? row.titleArabic : row.titleEnglish}
                    </TableCell>
                    <TableCell align="center" sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                      {lang === "ar" ? row.descriptionArabic : row.descriptionEnglish}
                    </TableCell>
                    <TableCell align="center" sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                      {row.price} {t(row.currency)}
                    </TableCell>
                    <TableCell align="center">
                      <Button size="small" color="primary" onClick={() => handelLecture(row.id)}>
                        {t("View more")}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography
            sx={{
              fontSize: "16px",
              margin: "5px",
              padding: "10px",
              background: "#f8f9f9",
              textAlign: "center",
            }}
          >
            {t('There are no special Lectures.')}
          </Typography>
        )}
      </Box>
    </Paper>
  );
}
